// extracted by mini-css-extract-plugin
export default {"privateModeSwitch":"DgIwzNZMWscL21Z7okez"};